import { createReducer } from 'redux-act';
//
import * as actions from './actions';

const initialState = {
  contentTags: [],
  contentTagsTree: [],
  globalCurriculumTree: [],
  globalMeeoppTopicTree: [],
};

const ContentTagsReducer = createReducer(
  {
    [actions.setContentTags]: (state, payload) => ({
      ...state,
      contentTags: payload,
    }),
    [actions.setContentTagTree]: (state, payload) => ({
      ...state,
      contentTagsTree: payload,
    }),
    [actions.setGlobalCurriculumTree]: (state, payload) => ({
      ...state,
      globalCurriculumTree: payload,
    }),
    [actions.setGlobalMeeoppTopicTree]: (state, payload) => ({
      ...state,
      globalMeeoppTopicTree: payload,
    }),
  },
  initialState
);

export default ContentTagsReducer;
